
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M18 4C18 5.10457 18.8954 6 20 6C21.1046 6 22 5.10457 22 4C22 2.89543 21.1046 2 20 2C18.8954 2 18 2.89543 18 4ZM18 4H14"></path><path d="M6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18C5.10457 18 6 18.8954 6 20ZM6 20H12"></path><path d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12M14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12M14 12H15C17.2091 12 19 13.7909 19 16V16C19 18.2091 17.2091 20 15 20H12M10 12H9C6.79086 12 5 10.2091 5 8V8C5 5.79086 6.79086 4 9 4H14"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowb",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
